import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useGetFiltersInfo from '../hooks/useGetFiltersInfo';
import OptionsSelector from '../ui/OptionsSelector';

const FuelTypeFilter = ({ type }) => {
  const {
    data, prevData, params, updateParams,
  } = useGetFiltersInfo();
  const { t } = useTranslation('search');

  const options = data?.fuelTypes || prevData?.fuelTypes || [];

  const onChange = (value) => {
    updateParams({
      fuels: value,
      page: 1,
    });
  };

  return (
    <OptionsSelector
      id="fuel-type-filter"
      onChange={onChange}
      options={options}
      placeholder={t('Search')}
      type={type}
      value={params.fuels}
    />
  );
};

FuelTypeFilter.propTypes = {
  type: PropTypes.string.isRequired,
};

export default FuelTypeFilter;
